import toolbarVariables from './toolbarVariables';

export default toolbarVariables;
